import { createBrowserHistory } from 'history';

import { BASE_PATH } from './configUtil';

const browserHistory = createBrowserHistory({ basename: BASE_PATH });

export { browserHistory };
